const devConfig = {
  api: "https://juicysuite.app/member/api/",
};

export default devConfig;
